<template>
  <!--  预算编制-->
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed; top: 0; z-index: 999; width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理</van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>
    <van-collapse v-model="activeNames"
                  v-if="this.inputForm.auditGroup
                  && this.inputForm.auditGroup.auditGroupDetailList
                  && this.inputForm.auditGroup.auditGroupDetailList.length>0">
      <van-collapse-item title="汇总审批信息" name="99">
        <div  style="margin-bottom: 10px">
          <div class="m-form" style="padding-left: 0">
            <div class="m-row" style="font-size: 15px">
              <div class="m-row-text">单据类型</div>
              <div class="m-row-content">{{ inputForm.auditGroup.businessTypeName }}</div>
            </div>
            <div class="m-row" style="font-size: 15px">
              <div class="m-row-text">单据数量</div>
              <div class="m-row-content">{{ inputForm.auditGroup.businessNum }}</div>
            </div>
            <div class="m-row" style="font-size: 15px">
              <div class="m-row-text">总金额（元）</div>
              <div class="m-row-content">{{Number(inputForm.auditGroup.totalBusinessAmount).toFixed(2) }}</div>
            </div>
            <div class="m-row" style="font-size: 15px">
              <div class="m-row-text">制单人</div>
              <div class="m-row-content">{{ inputForm.auditGroup.businessCreateByName }}</div>
            </div>
          </div>
        </div>
        <b-table  sticky-header="calc(100vh - 50px)" class="bgc-dark" head-variant="dark" responsive bordered
                 :items="inputForm.auditGroup.auditGroupDetailList" :fields="fields" :tbody-tr-class="rowClass">
          <template v-slot:head()="scope">
            <div class="text-nowrap" style="text-align:center; vertical-align: middle;font-size: 15px">
              {{ scope.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(businessName)="data">
            <div @click="viewBusinessData(data.item.businessId)" style="text-align: left; font-size: 15px">
              {{ data.item.businessName}}</div>
          </template>
          <template v-slot:cell(businessAmount)="data">
            <div @click="viewBusinessData(data.item.businessId)" style="text-align: center; font-size: 15px">
              {{ Number(data.item.businessAmount).toFixed(2)}}</div>
          </template>
          <template v-slot:table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.width }"
            >
          </template>
        </b-table>
      </van-collapse-item>
    </van-collapse>
    <div v-show="businessType==='contract'">
      <contractRequestFunds ref="contract"></contractRequestFunds>
    </div>
    <div v-show="businessType==='event'">
      <eventRequestFunds ref="event"></eventRequestFunds>
    </div>
    <div v-show="businessType==='travel'">
      <travel ref="travel"></travel>
    </div>
    <div v-show="businessType==='common'">
      <common ref="common"></common>
    </div>
    <div v-show="businessType==='personalTax'">
      <personalTax ref="personalTax"></personalTax>
    </div>
    <div v-show="businessType==='salary'">
      <salary ref="salary"></salary>
    </div>
    <div v-show="businessType==='socialWeal'">
      <socialWeal ref="socialWeal"></socialWeal>
    </div>
    <div v-show="businessType==='houseProvident'">
      <houseProvident ref="houseProvident"></houseProvident>
    </div>
    <div v-show="businessType==='tax'">
      <tax ref="tax"></tax>
    </div>
    <div v-show="businessType==='financial'">
      <financial ref="financial"></financial>
    </div>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import processRecord from "../../../../components/processRecord/processRecord";
import TaskService from "../../../../api/flowable/TaskService";
import ProcessService from "../../../../api/flowable/ProcessService";
import contractRequestFunds from "./contractRequestFunds";
import eventRequestFunds from "./eventRequestFunds";
import travel from "../claim/travel";
import common from "../claim/common";
import personalTax from "../claim/personalTax";
import salary from "../claim/salary";
import socialWeal from "../claim/socialWeal";
import tax from "../claim/tax";
import houseProvident from "../claim/houseProvident.vue";
import financial from "../claim/financial.vue";
import Vue from "vue";
import flowSettingService from "../../../../api/sys/flowSettingService";
import data from "bootstrap/js/src/dom/data";
import { Dialog } from 'vant';

export default {
  name: "costRequestFunds",
  data(){
    return {
      fields: [
        {key: 'index', stickyColumn: true, label: '序号', width: '40px'},
        {key: 'businessName', label: '单据名称', width: '175px'},
        {key: 'businessAmount', label: '金额（元）', stickyColumn: true, width: '175px'},
        // {key: 'code', label: '单据编号', width: '150px'},
        // {key: 'name', label: '单据名称', width: '120px'},
        // {key: 'requestAmount', label: '金额', width: '50px'},
      ],
      items: [
        // {id: '1931988114511769602', code: '支出报销-202506-0006', name: '001', requestAmount:800},
        // {id: '1931990241627877377', code: '支出报销-202506-0007', name: '002', requestAmount:1200}
      ],
      activeNames: ['1', '2', '3', '4', '5', '99'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
      businessType:'',
      inputForm:{
        auditGroup: {
          id: undefined,
          businessTypeName: undefined,
          businessNum: undefined,
          totalBusinessAmount: undefined,
          businessCreateByName: undefined,
          auditGroupDetailList: []
        },
      }
    }
  },
  components: {
    processRecord,
    contractRequestFunds,
    eventRequestFunds,
    travel,
    common,
    personalTax,
    salary,
    socialWeal,
    tax,
    houseProvident,
    financial
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    // let id = '1873565665911226370'
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
    if(!window.matchMedia("(orientation:portrait)").matches){
      dd.device.screen.resetView({
        onSuccess : function(result) {
        },
        onFail : function(err) {}
      });
    }
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.inputForm.id = id
      this.$nextTick(()=>{
        this.$flow.queryById(id, '/payment/costContractRequestFunds/getFundsBaseInfo').then(({ data }) => {
          //methods 请款方式（0：合同请款; 1：非合同请款；2：支出报销单）
          //businessType 支出报销单业务类型（0：通用支出报销；1：差旅费报销；2：个人所得税支出；3：薪酬支出（工资、奖金支出）；4：社保公积金支出；5：税费缴纳；6：资产购置支出；）
          const methodsMap = {
            '0': { type: 'contract', ref: this.$refs.contract,url:'/payment/costContractRequestFunds/queryById' },
            '1': { type: 'event', ref: this.$refs.event ,url:'/payment/costEventRequestFunds/queryById'},
            '2': {
              type: ['common', 'travel', 'personalTax', 'salary', 'socialWeal',  'tax', '', 'houseProvident','financial'],
              ref: [this.$refs.common, this.$refs.travel, this.$refs.personalTax, this.$refs.salary, this.$refs.socialWeal,this.$refs.tax, '', this.$refs.houseProvident, this.$refs.financial]
            }
          };
          if (data.methods in methodsMap) {
            let target = methodsMap[data.methods];
            if (Array.isArray(target.type)) {
              let index = parseInt(data.businessType);
              if (!isNaN(index) && index >= 0 && index < target.type.length) {
                this.$flow.queryById(id, '/payment/costEventClaim/queryById').then(({ data }) => {
                  this.inputForm = data
                  this.businessType = target.type[index];
                  target.ref[index].init(data);
                })
              }
            } else {
              this.$flow.queryById(id, target.url).then(({ data }) => {
                this.inputForm = data
                this.businessType = target.type;
                target.ref.init(data);
              })
            }
          }
        }).catch(e => {
          console.log(e)
        });
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(async () => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        const res = await this.$flow.queryById(this.inputForm.id, '/payment/costEventClaim/accountSubjectCheck')
        if(!res.data) {
          _this.$toast.fail({
            message: '请先设置并保存该单据的核算科目！',
            duration: 3000
          });
          return
        }

        let vars = {}
        // vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        let sendBy = ''
        let sendByDeptId = ''
        let sendByCompanyId = ''
        if(this.inputForm.flowStatus === 1) {
          sendBy = Vue.cookie.get('userId');
          const res1 = await new flowSettingService().queryUser(sendBy)
          sendByDeptId = res1.data.officeDTO.id
          sendByCompanyId = res1.data.companyDTO.id
        } else {
          const res3 = await new TaskService().queryByProcInsId(this.inputForm.procInsId)
          sendBy = res3.data.createBy
          sendByDeptId = res3.data.createDept
          sendByCompanyId = res3.data.createCompany
        }
        let createByDeptId = ''
        let createByCompanyId = ''
        const res2 = await new flowSettingService().queryUser(this.inputForm.createBy.id)
        createByDeptId = res2.data.officeDTO.id
        createByCompanyId = res2.data.companyDTO.id
        let operatorId = ''
        if(this.businessType === 'contract') {
          operatorId = this.inputForm.operatorId
        } else if(this.businessType === 'travel') {
          operatorId = this.inputForm.requestUserId.split(',')[0]
        } else {
          operatorId = this.inputForm.requestUserId
        }
        if(this.businessType === 'event') {
          vars = {
            sendBy: sendBy,
            sendByDeptId: sendByDeptId,
            sendByCompanyId: sendByCompanyId,
            createBy: this.inputForm.createBy.id,
            createByDeptId: createByDeptId,
            createByCompanyId: createByCompanyId,
            paymentCompanyId: this.inputForm.paymentCompanyId,
          }
        } else {
          vars = {
            sendBy: sendBy,
            sendByDeptId: sendByDeptId,
            sendByCompanyId: sendByCompanyId,
            createByDeptId: createByDeptId,
            createByCompanyId: createByCompanyId,
            createBy: this.inputForm.createBy.id,
            operatorId: operatorId,
            operatorDeptId: this.inputForm.operatorDeptId,
            paymentCompanyId: this.inputForm.paymentCompanyId,
          }
        }
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey
          }
          // _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          const businessTypeToUrlMap = {
            contract: '/payment/costContractRequestFunds/startFlow',
            event: '/payment/costEventRequestFunds/startFlow',
            default: '/payment/costEventClaim/startFlow'
          };
          const url = businessTypeToUrlMap[this.businessType] || businessTypeToUrlMap.default;
          _this.$flow.startFlow(form, url)
          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {

      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          // _this.inputForm.flowType = 3;
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey
          }
          const businessTypeToUrlMap = {
            contract: '/payment/costContractRequestFunds/startFlow',
            event: '/payment/costEventRequestFunds/startFlow',
            default: '/payment/costEventClaim/startFlow'
          };
          const url = businessTypeToUrlMap[this.businessType] || businessTypeToUrlMap.default;
          _this.$flow.startFlow(form, url);

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    viewBusinessData(id){
      this.init(id)
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.businessId == this.inputForm.id){
        return 'success'
      }
      // return ''
    }
  }
}
</script>

<style scoped>

 ::v-deep .success td {
  background-color: #d1e7dd!important;
}
/** {
  margin: 0;
  padding: 0;
}*/
.unitTitle {
  width: 100%;
  padding-left: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}
.m-form {
  width: 100%;
  /*padding: 10px;*/
  font-size: 12px;
  box-sizing: border-box;
  /*border-bottom: 1px solid #eee;*/
  padding-left: 16px;
  margin-bottom: 10px;
}
.title {
  width: calc(100vw - 20px);
  height: 30px;
  background-color: #eeeeee;
  line-height: 30px;
  font-weight: bold;
  padding-left: 5px;
  box-sizing: border-box;
  /*// margin-bottom: 20rpx;*/
}

.m-row {
  display: flex;
  width: calc(100%);
  border: 1px solid #eee;
  border-bottom: 0px;
}

.m-row:last-child {
  border-bottom: 1px solid #eee;
}

.m-row-text {
  width: 110px;
  padding-left: 5px;
  border-right: 1px solid #eee;
  /*border-bottom: 1px solid #eee;*/
  display: flex;
  align-items: center;
  /*background-color: #dedede;*/
}

.m-row-content {
  width: calc(100% - 110px);
  color: black;
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
}

.large-content {
  width: calc(100% - 110px);
  min-height: 30px;
  height: auto;
  padding-left: 10px;
  overflow: hidden;
}
</style>
